import styled from '@emotion/styled';
import React from 'react';
import {
  TextField,
} from '../../../../../../../components/TextField';
import { findAllServico } from '../../../../../../../services/vizi-plano-tuss';
import { SelectSearch } from '../../../../../../../components/select/SelectSearch';
import { useEffect } from 'react';
import { useState } from 'react';

export const DadosPlanoTuss = ({ dadosPlanoTuss, handleChange, whitelabel }) => {
  const dadosInputs = [
    { label: 'Carência', field: 'carencia', type: 'number' },
    { label: 'Quantidade disponível', field: 'qtdeDisponivel', type: 'number', max:5 },
    { label: 'Desconto', field: 'desconto', mask: 'percentil', type: 'string' },
    {
      label: 'Desconto após o limite do plano',
      field: 'descontoAposLimite',
      mask: 'percentil',
      type: 'string',
    },
  ];

  const [search,setSearch]= useState("")
  const [procedimentos,setProcedimentos]=useState([])

  useEffect(()=>{
    carregarProcedimentos({resetValues:true})
  },[search])

  const carregarProcedimentos = async (resetValues)=>{

     const response = await  findAllServico({search:search},whitelabel)
     setProcedimentos(response)
  }

  const handleChangeSelect = (event)=>{
   setSearch(event)
  }

  return (
    <Content>
      <Row>
        {dadosInputs.map((tipo, index) => {
          const { label, field, mask, type, max } = tipo || {};
          const valueString = type === 'string' ? String(dadosPlanoTuss?.[field]) : dadosPlanoTuss?.[field];

          return (
            <TextField
              key={index}
              label={label}
              placeholder="Digite o valor"
              value={valueString || null}
              onChange={(e) => handleChange(field, e.target.value)}
              maxLength={max}
              type={type}
              mask={mask}
            />
          );
        })}
      </Row>
      <SubTitle>Procedimento</SubTitle>
      <Column>
        <SelectSearch
          name="status"
          value={dadosPlanoTuss?.servicoExibicao}
          elements={procedimentos || []}
          onInputChange={(e) => handleChangeSelect(e)}
          onChange={(e) => handleChange('servicoExibicao', e)}
          isClearable={false}
        />
      </Column>
    </Content>
  );
};

const Content = styled.div`
  height: 100%;
  overflow-y: auto;
  display: grid;
  gap: 16px;
  grid-template-rows: repeat(3, max-content);
`;

const Row = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
`;
const Column = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  max-width: 500px;
`;
const SubTitle = styled.span`
  font-weight: 700;
`;
